import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isShowLoading: false,
    isBwtHybrid: true,
    centerPoint: null,
    toMappoint: null,
    umbrella_status: null,
    reLogin: 0,
    lockNo: null,
    success: false
  },
  mutations: {
    isShowLoading (state, isShow) {
      state.isShowLoading = isShow
    },
    isBwtHybrid (state, channel) {
      state.isBwtHybrid = channel
    },
    newCenterPoint (state, msg) {
      state.centerPoint = msg
    },
    newMappoint (state, point) {
      state.toMappoint = point
    },
    newStatus (state, status) {
      state.umbrella_status = status
    },
    newLogin (state, login) {
      state.reLogin = login
    },
    lockNo (state, No) {
      state.lockNo = No
    },
    success (state, bool) {
      state.success = bool
      setTimeout(() => {
        state.success = false
      }, 4000)
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js